import useConfigurationStore from '../store/configurationStore';

export default function DependencyNotice() {
    const { validation } = useConfigurationStore();

    if (validation.valid && validation.warnings.length === 0) return null;

    return (
        <div className="ast-dep-notice">
            {validation.errors.map((err, i) => (
                <div key={i} className="ast-dep-notice__item ast-dep-notice__item--error">
                    <span className="ast-dep-notice__icon">&#9888;</span>
                    {err.message}
                </div>
            ))}
            {validation.warnings.map((warn, i) => (
                <div key={i} className="ast-dep-notice__item ast-dep-notice__item--info">
                    <span className="ast-dep-notice__icon">&#8505;</span>
                    {warn.message}
                </div>
            ))}
        </div>
    );
}
